import { User } from '../types';

// eslint-disable-next-line import/prefer-default-export
export const getFullName = (user?: User) => {
  const fullName = `${user?.firstName || ''} ${user?.lastName || ''}`;
  return fullName.trim();
};
